import Bowser from "bowser";

export type AgentInfo = {
    browser: {
        name?: string,
        version?: string
    },
    plattformType?: string,
    os: {
        name?: string,
        version?: string
    }
}

const empty: AgentInfo = { browser: {}, os: {} };

const createUserAgentInfo = () => {
    try {
        const browser = Bowser.getParser(window.navigator.userAgent);
        const browserDetails = browser.getBrowser();
        const plattformType = browser.getPlatformType(true); // desktop
        const os = browser.getOS();
        const agentInfo: AgentInfo = {
            browser: {
                name: browserDetails.name,
                version: browserDetails.version
            },
            plattformType,
            os: {
                name: os.name,
                version: os.versionName
            }
        };

        return agentInfo;
    } catch (error) { }

    return empty;
}

const BrowserDetection = {
    createUserAgentInfo
}

export default BrowserDetection